import React from "react";
import { useSelector } from "react-redux";
import isEmpty from "../../../../../store/validation/is-Empty";
import { Image } from "react-bootstrap";
import ReadMore from "../../../../reusableComponents/ReadMore";
const ListMerchantTableBody = (props) => {
  return (
    <tbody>
      <tr style={{ display: "contents" }}>
        <td
          style={{ paddingLeft: 28, width: "10%", verticalAlign: "middle" }}
          className="coloradio"
        >
          <input
            type="radio"
            id="restaurants"
            name="restaurants"
            // selected={props.selectedCheck}
            onChange={() => props?.selectexp(props?.expdata)}
            value={props?.expdata}
            checked={props?.expdata?._id == props?.selectedExp?._id}
          />
        </td>
        <td style={{ width: "23%" }}>#{props?.expdata?._id}</td>
        <td style={{ width: "18%" }}>{props?.expdata?.name}</td>
        <td style={{ width: "18%" }}>
          <ReadMore
            text={props?.expdata?.description || ""}
            minLength={
              props?.expdata?.description?.length < 50
                ? props?.expdata?.description?.length
                : 50
            }
            charLength={
              props?.expdata?.description && props?.expdata?.description?.length
            }
          />
        </td>
        <td style={{ width: "10%" }}>{props?.expdata?.venueAddress || ""}</td>
        <td style={{ width: "10%" }}>{props?.expdata?.expId}</td>
        <td style={{ width: "10%" }}>
          <Image
            src={props?.expdata?.photoThumbnails[0]}
            alt={"exp  image"}
            // title={"Restaurant Logo"}
            fluid
            className="img-thumbnail h-auto w-50 mb-2"
          />
        </td>
      </tr>
    </tbody>
  );
};

export default ListMerchantTableBody;
